import SubPageHeader from '../SubPageHeader';
import PaymentMethodsEditor from '../PaymentMethodsEditor';

/** Settings → وسائل الدفع (SellGo's own database). */
export default function PaymentMethodsSection({ onBack }) {
  return (
    <div className="flex flex-col min-h-full" dir="rtl">
      <SubPageHeader title="وسائل الدفع" onBack={onBack} />
      <div className="p-4">
        <PaymentMethodsEditor />
      </div>
    </div>
  );
}
